<template>
  <div>
    <div
      v-for="(setParams, setIndex) in sets"
      :key="'set'+setIndex"
      class="align-center mb-2"
    >
      <div
        class="grey--text text--darken-1 d-inline-block"
        style="width: 50px"
        :class="{ 'caption': dense, 'text-body-1': !dense }"
      >
        {{ $t("training_builder.configure.set", {set: setIndex + 1}) }}:
      </div>

      <exercise-param-label-helper
        :label="$t('reps.label')"
        :dense="dense"
        :param="setParams.NMRP"
      />

      <exercise-param-label-helper
        :label="$t('rest_between_reps.label')"
        :dense="dense"
        :param="setParams.RSRPDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('rest_after_set.label')"
        :dense="dense"
        :param="setParams.RSSTDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.weight.title')"
        :dense="dense"
        :param="convertWeightByTimezone(setParams.WGHT, user.organisation_settings.timezone, true)"
        :suffix="weightSuffix(user.organisation_settings.timezone)"
      />

      <exercise-param-label-helper
        :label="$t('ground_contacts.label')"
        :dense="dense"
        :param="setParams.NUMGC"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.no_of_throws')"
        :dense="dense"
        :param="setParams.NOTHR"
      />
    </div>
  </div>
</template>
<script>

import ExerciseParamLabelHelper from '@/components/training-builder/ExerciseParamLabelHelper.vue'
import { convertWeightByTimezone, weightSuffix } from '@/components/training-builder/helpers'

export default {
  name: 'BallisticsParamsView',
  components: { ExerciseParamLabelHelper },
  props: {
    sets: {
      type: Array,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    hasRealizations: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    }
  },
  methods: { weightSuffix, convertWeightByTimezone }
}
</script>
